import React, {useEffect, useRef, useState} from 'react';
import {observer} from "mobx-react";
import image_totem from "../images/totemNoContent.png";
import "../styles/listeTotems.scss";
import {useParams} from "react-router-dom";
import {useStores} from "../stores/Context";
import {useHistory} from "react-router-dom";
import moment from 'moment';
import 'moment/locale/fr';
import BtnPrimary from "../boiteAOutils/BtnPrimary";
import {runInAction} from "mobx";
import {createAxiosEntrepriseInstance} from "../axiosEntreprise";
import axiosUserInstance from '../axiosUser';
import CrayonSvg from "../boiteAOutils/SVG/CrayonSvg";
import ModalPrimary from "../boiteAOutils/ModalPrimary";
/*
 * Soketi
 */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import LogoSeizoSSvg from "../boiteAOutils/SVG/LogoSeizoSSvg";
import BtnSecondary from "../boiteAOutils/BtnSecondary";
import styles from "../boiteAOutils/BtnTiertary.module.scss";
import WorkspaceSelector from "../components/WorkspaceSelector";
import {buildScreenThumbnailUrl} from "../utils/dashboardThumbnail";

moment.locale('fr');

const Totem = observer((props) => {
    const params = useParams();
    const ent = params.ent; // compatibilité ascendante (anciennes URLs /:ent)
    const [listeTotem, setListeTotem] = useState([]);
    const [allTotem, setAllTotem] = useState([]);
    const {widgetStore, uiStore, workspaceStore} = useStores();
    const [_token, setToken] = useState(widgetStore.getCookie('current_apiToken') || widgetStore.getCookie((ent || '') + '_apiToken'));
    const [showSignOut, setShowSignOut] = useState(false);
    const [totemToDelete, setTotemToDelete] = useState(null);
    const [isDeletingTotem, setIsDeletingTotem] = useState(false);
    const [deleteTotemError, setDeleteTotemError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    // ── Édition inline du nom de l'espace ──
    const [isEditingNom, setIsEditingNom] = useState(false);
    const [editNomValue, setEditNomValue] = useState('');
    const [nomEspaceDisplay, setNomEspaceDisplay] = useState('');
    const [savingNom, setSavingNom] = useState(false);
    const editNomInputRef = useRef(null);
    const history = useHistory();
    // ── SSO FO → BO ──
    const [loadingBo, setLoadingBo] = useState(false);
    const [showHelpUnavailable, setShowHelpUnavailable] = useState(false);

    // Utiliser currentEntrepriseInfos (Phase 2) avec fallback sur l'ancien cookie préfixé
    const cookieEntreprise = widgetStore.getCookie('currentEntrepriseInfos') || widgetStore.getCookie((ent || '') + '_currentEntrepriseInfos');
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();
    // State dédié pour plan_key — permet de forcer un re-render quand le cookie est mis à jour
    const [planKey, setPlanKey] = useState(entrepriseInfos.plan_key || null);
    const nomEntreprise = nomEspaceDisplay || entrepriseInfos.nomEntreprise || '';
    const canDeleteTotems = (() => {
        try {
            const userInfos = JSON.parse(widgetStore.getCookie('currentUserInfos') || '{}');
            const roleId = entrepriseInfos?.role?.id;
            return Boolean(userInfos.is_super_admin || entrepriseInfos?.is_admin || (roleId && roleId <= 2));
        } catch (_) {
            return false;
        }
    })();

    /*
    * Soketi
    */
    window.Pusher = Pusher;
    useEffect(() => {
        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WS_KEY,
            secret: process.env.REACT_APP_WS_SECRET,
            wsHost: process.env.REACT_APP_WS_URL,
            wsPort: 6001,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu',
        });

        const connectionEvents = ['connected', 'disconnected', 'connecting', 'reconnecting', 'error'];
        connectionEvents.forEach(event => {
            echo.connector.pusher.connection.bind(event, (err) => {
                console.log(`Totems_WS::${event}`);
            });
        });

        // Evenement pour mettre à jour le composant YT en temps reel.
        const _wsEnt = ent || (entrepriseInfos && entrepriseInfos.code) || 'default';
        echo.channel(_wsEnt + '-Totems_refreshChannel')
            .listen('Totems\\TotemsRefreshEvent', (res) => {
                console.log('WS::TotemsRefreshEvent');
                getAllTotem().then();
            });

        // Cleanup function to unsubscribe when the component unmounts
        return () => {
            echo.disconnect();
        };
    }, []);

    useEffect(() => {
        uiStore.isRedirected = false;
    }, []);

    // Filtrage combiné : workspace actif + recherche texte
    const applyFilters = (totems, term, activeWs) => {
        let filtered = totems;
        // Filtre par workspace (null = tous les écrans)
        if (activeWs) {
            filtered = filtered.filter(t => t.workspace_id === activeWs.id);
        }
        // Filtre par texte
        if (term) {
            filtered = filtered.filter(t =>
                t.tot_nom.toLowerCase().includes(term.toLowerCase())
            );
        }
        return filtered;
    };

    useEffect(() => {
        setListeTotem(applyFilters(allTotem, searchTerm, workspaceStore.activeWorkspace));
    }, [searchTerm, workspaceStore.activeWorkspace]);

    useEffect(() => {
        if (listeTotem.length === 0) {
            getAllTotem().then();
        }
    }, [_token]);

    // Rafraîchir plan_key dans le cookie si absent (sessions antérieures au fix badge)
    useEffect(() => {
        if (!entrepriseInfos.plan_key && _token) {
            axiosUserInstance.get('/api/mon-compte/espace')
                .then(r => {
                    const planKey = r.data?.licence?.offre;
                    if (planKey) {
                        const raw = widgetStore.getCookie('currentEntrepriseInfos');
                        if (raw) {
                            try {
                                let infos;
                                try { infos = JSON.parse(raw); } catch (_) { infos = JSON.parse(decodeURIComponent(raw)); }
                                infos.plan_key = planKey;
                                document.cookie = `currentEntrepriseInfos=${JSON.stringify(infos)};path=/;SameSite=None;Secure;max-age=86400`;
                                // Forcer un re-render en mettant à jour le state
                                setNomEspaceDisplay(infos.nomEntreprise || '');
                            } catch (_) { /* ignore */ }
                        }
                    }
                })
                .catch(() => {});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_token]);

    const timeFromNow = (dateString) => {
        return moment(dateString, "YYYY-MM-DD HH:mm:ss").fromNow();
    }

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    }

    const handleChangeEntreprise = () => {
        history.push('/choixEspace'); // Navigue vers la page de choix d'espace
    };

    // ── SSO FO → BO : ouvre le Back-Office sans ressaisir un OTP ──
    const handleOpenBo = async () => {
        setLoadingBo(true);
        try {
            const res = await axiosUserInstance.post('/api/bo-access-token', {
                entreprise_code: entrepriseInfos?.code || null
            });
            if (res.data?.url) {
                window.open(res.data.url, '_blank');
            }
        } catch (e) {
            console.error('Erreur SSO BO', e);
        } finally {
            setLoadingBo(false);
        }
    };

    // ── Édition inline du nom de l'espace ──
    const handleEditNom = () => {
        setEditNomValue(nomEntreprise);
        setIsEditingNom(true);
        setTimeout(() => { if (editNomInputRef.current) editNomInputRef.current.focus(); }, 50);
    };

    const handleSaveNom = async () => {
        if (!editNomValue.trim() || editNomValue.trim() === nomEntreprise) {
            setIsEditingNom(false);
            return;
        }
        setSavingNom(true);
        try {
            const entrepriseCode = entrepriseInfos.code || '';
            const headers = entrepriseCode ? { 'X-Entreprise-Code': entrepriseCode } : {};
            const res = await axiosUserInstance.put('/api/mon-compte/espace', { libelle: editNomValue.trim() }, { headers });
            const nouveauNom = res.data.libelle || editNomValue.trim();
            // Mettre à jour l'état local
            setNomEspaceDisplay(nouveauNom);
            // Mettre à jour le cookie currentEntrepriseInfos
            const updatedInfos = { ...entrepriseInfos, nomEntreprise: nouveauNom };
            document.cookie = `currentEntrepriseInfos=${JSON.stringify(updatedInfos)}; path=/; SameSite=None; Secure`;
            setIsEditingNom(false);
        } catch (err) {
            console.error('handleSaveNom error:', err);
        } finally {
            setSavingNom(false);
        }
    };

    const handleCancelEditNom = () => {
        setIsEditingNom(false);
        setEditNomValue('');
    };

    const handleEditNomKeyDown = (e) => {
        if (e.key === 'Enter') handleSaveNom();
        if (e.key === 'Escape') handleCancelEditNom();
    };

    const getAllTotem = async () => {
        try {
            const entrepriseCode = entrepriseInfos.code || '';
            const headers = entrepriseCode ? { 'X-Entreprise-Code': entrepriseCode } : {};
            const res = await axiosUserInstance.get(`/api/getAllTotem`, { headers });
            const liste = res.data;
            // Appliquer les filtres actifs après chargement
            setAllTotem(liste);
            setListeTotem(applyFilters(liste, searchTerm, workspaceStore.activeWorkspace));
        } catch (err) {
            console.log("getAllTotem", err)
        }
    }

    const handleDeleteTotem = async () => {
        if (!totemToDelete || isDeletingTotem) return;
        setIsDeletingTotem(true);
        setDeleteTotemError('');
        try {
            const entrepriseCode = entrepriseInfos.code || '';
            const headers = entrepriseCode ? { 'X-Entreprise-Code': entrepriseCode } : {};
            const response = await axiosUserInstance.delete(`/api/mon-compte/totems/${totemToDelete.id_totem}`, { headers });
            // Certains anciens middlewares renvoient une erreur métier avec HTTP 200.
            // Ne jamais fermer la modale ni faire croire à une suppression réussie
            // tant que l'API n'a pas confirmé l'identifiant effectivement supprimé.
            if (response.data?.deleted_totem_id !== totemToDelete.id_totem) {
                throw new Error(response.data?.message || 'La suppression de cet écran n’a pas été confirmée.');
            }
            setTotemToDelete(null);
            await getAllTotem();
        } catch (error) {
            setDeleteTotemError(error.response?.data?.message || error.message || 'La suppression de cet écran a échoué. Réessayez.');
        } finally {
            setIsDeletingTotem(false);
        }
    };

    const TotemElement = ({totem}) => {
        const handleClick = (url) => {
            // change window location
            window.location.href = url;
        }

        const openEditLink = (url) => {
            runInAction(() => {
                uiStore.isRedirected = true;
            });
            history.push(url);
        };

        const requestDelete = () => {
            setDeleteTotemError('');
            setTotemToDelete(totem);
        };

        return (
            <div className={"totem__element"}>
                {/*<p className={'totem__time'}>il y a 6 heures</p>*/}
                <p className={'totem__time'}>{totem.tot_derniere_actualisation ? timeFromNow(totem.tot_derniere_actualisation) : 'N/C'}</p>
                <hr className={'totem__hr'}/>
                <h2 className={'totem__name'}>{totem.tot_nom}</h2>
                <div className='totem__image'>
                    <span className="totem__previewLabel" aria-hidden="true">
                        <span className="totem__previewPulse"/> Aperçu en direct
                    </span>
                    <img
                        src={buildScreenThumbnailUrl(process.env.REACT_APP_API_URL, totem.id_totem, totem.tot_derniere_actualisation)}
                        alt={`Aperçu de l’écran ${totem.tot_nom}`}
                        className={`imgContainer`}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = image_totem;
                        }}
                    />
                </div>
                <div className={"flex flex-col items-center"}>
                    <BtnPrimary
                        onClick={() => handleClick(process.env.REACT_APP_PATH_HOME_PAGE + 'app/' + totem.id_totem)}>Voir
                        l'écran</BtnPrimary>
                    <BtnSecondary
                        onClick={() => openEditLink('/app/' + totem.id_totem)}
                        styleSpan={{display: "flex", alignItems: "center", gap: "8px", fontSize: "16px"}}
                    ><CrayonSvg/> Ouvrir l'éditeur</BtnSecondary>
                    {canDeleteTotems && (
                        <button
                            type="button"
                            onClick={requestDelete}
                            style={{
                                marginTop: '0.6rem', border: 'none', background: 'transparent', color: '#d73737',
                                fontSize: '0.82rem', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer',
                            }}
                        >
                            Supprimer cet écran
                        </button>
                    )}
                </div>
            </div>
        )
    }

    const AddTotemElement = () => {
        return (
            <div className={"totem__addElement"}>
                <div className='totemAdd__main'>
                    <h2>Ajouter un nouvel écran</h2>
                    <div className={'ArrowContainer'}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                             stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
                        </svg>
                    </div>
                    <BtnSecondary onClick={() => history.push('/mon-compte')}
                                  styleSpan={{fontSize: "16px"}}>Gérer mon abonnement et mes écrans</BtnSecondary>
                </div>
            </div>
        )
    }

    const SignOut = ({show}) => {
        if (!show) return null;

        const signOut = () => {
            const cookies = document.cookie.split(";"); // Récupère tous les cookies
            for (let cookie of cookies) {
                const cookieName = cookie.split("=")[0].trim(); // Récupère le nom du cookie
                // Supprime le cookie en définissant sa date d'expiration dans le passé
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
            }
            // Recharge la page (optionnel)
            window.location.reload();
        }

        return (
            <ModalPrimary
                textTitle={"Vous allez être déconnecté et redirigé vers la page de connexion"}
                textBtnValidate={"Oui, continuer"}
                textBtnCancel={"Non, rester connecté"}
                onValidate={() => signOut()}
                onCancel={() => setShowSignOut(false)}
            />
        )
    }

    return (
        <div className={"listeTotems"}>
            <div className='mainContainer'>
                {/* ── Hero Header ── */}
                <div style={{
                    background: '#002335',
                    borderRadius: '16px',
                    padding: '2rem 2.5rem',
                    marginBottom: '2rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '1rem',
                    boxShadow: '0 4px 24px rgba(0,35,53,0.15)',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <LogoSeizoSSvg width="36" height="46"/>
                            <span style={{
                                color: 'rgba(255,255,255,0.75)',
                                fontSize: '14px',
                                fontFamily: 'Nunito, sans-serif',
                                letterSpacing: '0.1em',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                            }}>Mon espace</span>
                        </div>
                        {/* Nom de l'espace — édition inline */}
                        {isEditingNom ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.25rem' }}>
                                <input
                                    ref={editNomInputRef}
                                    type="text"
                                    value={editNomValue}
                                    onChange={e => setEditNomValue(e.target.value)}
                                    onKeyDown={handleEditNomKeyDown}
                                    disabled={savingNom}
                                    style={{
                                        fontSize: '2rem',
                                        fontFamily: 'Nunito, sans-serif',
                                        fontWeight: 800,
                                        color: '#002335',
                                        background: 'rgba(255,255,255,0.95)',
                                        border: '2px solid #00B0FF',
                                        borderRadius: '8px',
                                        padding: '0.2rem 0.75rem',
                                        outline: 'none',
                                        minWidth: '220px',
                                        maxWidth: '400px',
                                    }}
                                />
                                <button
                                    onClick={handleSaveNom}
                                    disabled={savingNom}
                                    title="Valider"
                                    style={{
                                        background: '#00B0FF',
                                        border: 'none',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        padding: '0.3rem 0.75rem',
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        cursor: savingNom ? 'wait' : 'pointer',
                                        fontFamily: 'Nunito, sans-serif',
                                    }}
                                >{savingNom ? '...' : '✓'}</button>
                                <button
                                    onClick={handleCancelEditNom}
                                    disabled={savingNom}
                                    title="Annuler"
                                    style={{
                                        background: 'transparent',
                                        border: '1px solid rgba(255,255,255,0.4)',
                                        borderRadius: '6px',
                                        color: 'rgba(255,255,255,0.8)',
                                        padding: '0.3rem 0.75rem',
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        cursor: 'pointer',
                                        fontFamily: 'Nunito, sans-serif',
                                    }}
                                >×</button>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <h1 style={{
                                    color: '#fff',
                                    fontSize: '2.5rem',
                                    fontFamily: 'Nunito, sans-serif',
                                    fontWeight: 800,
                                    margin: 0,
                                    lineHeight: '1.1',
                                    textShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                }}>{nomEntreprise}</h1>
                                <button
                                    onClick={handleEditNom}
                                    title="Modifier le nom de l'espace"
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        opacity: 0.6,
                                        transition: 'opacity 0.2s',
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                                    onMouseLeave={e => e.currentTarget.style.opacity = '0.6'}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.25rem' }}>
                            <span style={{
                                background: entrepriseInfos.subscriber ? 'rgba(102,190,99,0.25)' : 'rgba(248,213,65,0.25)',
                                border: `1px solid ${entrepriseInfos.subscriber ? '#66BE63' : '#F8D541'}`,
                                color: entrepriseInfos.subscriber ? '#66BE63' : '#F8D541',
                                borderRadius: '20px',
                                padding: '2px 12px',
                                fontSize: '12px',
                                fontWeight: 700,
                                fontFamily: 'Nunito, sans-serif',
                                letterSpacing: '0.05em',
                            }}>
                                {(() => {
                                    if (!entrepriseInfos.subscriber) return 'Basique';
                                    const labels = { basique: 'Basique', premium: '\u2726 Premium', industriel: '\u2726 Site industriel' };
                                    return labels[entrepriseInfos.plan_key] || '\u2726 Premium';
                                })()}
                            </span>
                            <span style={{
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: '13px',
                                fontFamily: 'Nunito, sans-serif',
                            }}>
                                {listeTotem.length} écran{listeTotem.length > 1 ? 's' : ''} actif{listeTotem.length > 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
                        {!entrepriseInfos.subscriber && (
                            <button
                                onClick={() => history.push('/pricing')}
                                style={{
                                    background: '#F8D541',
                                    border: 'none',
                                    borderRadius: '8px',
                                    color: '#002335',
                                    padding: '0.5rem 1rem',
                                    fontSize: '13px',
                                    fontFamily: 'Nunito, sans-serif',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    transition: 'opacity 0.2s',
                                }}
                                onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                            >
                                ✦ Passer à Premium
                            </button>
                        )}
                    </div>
                </div>

                {/* Titre + Sélecteur de workspace */}
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '0.5rem'}}>
                    <h2 className={'subTitle__page'} style={{margin: 0}}>Vos écrans</h2>
                    <WorkspaceSelector
                        ent={ent}
                        onWorkspaceChange={() => {
                            setListeTotem(applyFilters(allTotem, searchTerm, workspaceStore.activeWorkspace));
                        }}
                    />
                </div>

                <div className="search__container">
                    <svg className={"w-2/3 float-right search__loupeIcon"} xmlns="http://www.w3.org/2000/svg" width="30"
                         height="30" viewBox="0 0 30 30" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M12 6.00005C8.68627 6.00005 5.99999 8.68634 5.99999 12C5.99999 15.3137 8.68627 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68634 15.3137 6.00005 12 6.00005ZM3 12C3 7.02949 7.02943 3.00006 12 3.00006C16.9705 3.00006 20.9999 7.02949 20.9999 12C20.9999 13.9438 20.3838 15.7436 19.3361 17.2148L26.5606 24.4393C27.1464 25.0251 27.1464 25.9749 26.5606 26.5606C25.9748 27.1464 25.0251 27.1464 24.4393 26.5606L17.2148 19.3361C15.7435 20.3838 13.9437 21 12 21C7.02943 21 3 16.9706 3 12Z"
                              fill="#A8B0B3"/>
                    </svg>
                    <input
                        type="text"
                        className={'w-2/3 float-right mb-5'}
                        placeholder={'Rechercher un écran'}
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                    {searchTerm && ( // Affichez l'icône seulement si searchTerm n'est pas vide
                        <svg
                            onClick={() => setSearchTerm('')} // Effacez le texte lors du clic
                            style={{position: 'absolute', top: '10px', right: '10px'}}
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            fill="currentColor"
                            className="bi bi-x"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    )}
                </div>
                <div className={"w-full grid grid-cols-3 gap-x-4 gap-y-8"}>

                    {
                        listeTotem.map((totem) => {
                            return <TotemElement totem={totem}/>
                        })
                    }
                    <AddTotemElement/>
                </div>
                <div className={"totem__actions mt-4"}>
                    <h1 className={'mb-2'}>Actions</h1>
                    <div className="totem__actionsGrp">
                        <button className={'totem__actionBtn'}
                                onClick={() => setShowHelpUnavailable(true)}>
                            <svg width="20" height="20" viewBox="0 0 21 29" fill="none"
                                 className={'mr-3 h-6 w-6'}
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.23094 21.294C9.0176 21.294 8.83094 21.2273 8.67094 21.094C8.51094 20.934 8.43094 20.734 8.43094 20.494C8.43094 20.2806 8.43094 20.0673 8.43094 19.854C8.43094 19.6406 8.43094 19.4273 8.43094 19.214C8.5376 18.174 8.8176 17.254 9.27094 16.454C9.75094 15.6273 10.2976 14.8806 10.9109 14.214C11.5509 13.5206 12.1776 12.8673 12.7909 12.254C13.4309 11.6406 13.9643 11.0406 14.3909 10.454C14.8443 9.84063 15.1109 9.21396 15.1909 8.57396C15.2709 7.80063 15.1109 7.1473 14.7109 6.61396C14.3376 6.08063 13.8176 5.68063 13.1509 5.41396C12.5109 5.12063 11.8309 4.97396 11.1109 4.97396C9.8576 4.97396 8.83094 5.28063 8.03094 5.89396C7.23094 6.5073 6.68427 7.49396 6.39094 8.85396C6.31094 9.17396 6.1776 9.41396 5.99094 9.57396C5.80427 9.7073 5.55094 9.77396 5.23094 9.77396H1.83094C1.59094 9.77396 1.3776 9.69396 1.19094 9.53396C1.03094 9.3473 0.950938 9.1073 0.950938 8.81396C0.977604 7.7473 1.2176 6.72063 1.67094 5.73396C2.15094 4.72063 2.83094 3.81396 3.71094 3.01396C4.6176 2.21396 5.71094 1.5873 6.99094 1.13396C8.27094 0.653963 9.7376 0.413963 11.3909 0.413963C13.2043 0.413963 14.7243 0.653963 15.9509 1.13396C17.2043 1.5873 18.1909 2.1873 18.9109 2.93396C19.6576 3.68063 20.1909 4.49396 20.5109 5.37396C20.8309 6.2273 20.9776 7.0673 20.9509 7.89396C20.8976 8.9073 20.6709 9.81396 20.2709 10.614C19.8709 11.414 19.3776 12.1606 18.7909 12.854C18.2043 13.5206 17.6043 14.1873 16.9909 14.854C16.3776 15.494 15.8309 16.1473 15.3509 16.814C14.8976 17.4806 14.5909 18.1873 14.4309 18.934C14.3776 19.174 14.3376 19.414 14.3109 19.654C14.2843 19.8673 14.2576 20.0806 14.2309 20.294C14.1243 20.614 13.9909 20.8673 13.8309 21.054C13.6709 21.214 13.4443 21.294 13.1509 21.294H9.23094ZM9.11094 28.814C8.84427 28.814 8.6176 28.7206 8.43094 28.534C8.24427 28.3473 8.15094 28.1206 8.15094 27.854V24.374C8.15094 24.0806 8.24427 23.8406 8.43094 23.654C8.6176 23.4673 8.84427 23.374 9.11094 23.374H12.9909C13.2843 23.374 13.5243 23.4673 13.7109 23.654C13.8976 23.8406 13.9909 24.0806 13.9909 24.374V27.854C13.9909 28.1206 13.8976 28.3473 13.7109 28.534C13.5243 28.7206 13.2843 28.814 12.9909 28.814H9.11094Z"
                                    fill="#002335"/>
                            </svg>
                            Centre d'aide
                        </button>

                    </div>
                </div>
            </div>
            <div className={"liste_ecrans_footer"}>
                <div className="image__footer"></div>
                <div className={"logo_version"}>
                    <LogoSeizoSSvg width="36" height="46"/>
                    <div className={"version"}>v2.13.9</div>
                </div>

                <div className={"content"} style={{display: "flex", alignItems: "center", gap: "12px"}}>
                        <span className={"texte"}>
                            Vous êtes connecté en tant que&nbsp;
                            <span className={"gras"}>
                                {widgetStore.getCookie("currentUserInfos") ? JSON.parse(widgetStore.getCookie("currentUserInfos")).prenom : ''}.
                            </span>
                        </span>
                    {/* Séparateur */}
                    <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", flexShrink: 0}}/>
                    <BtnSecondary onClick={() => history.push('/mon-compte')} children={"Mon Compte"}/>
                    <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", flexShrink: 0}}/>
                    {/* Afficher le bouton "Changer d'espace" uniquement si l'utilisateur a plusieurs espaces */}
                    {widgetStore.getCookie("currentUserInfos") &&
                        JSON.parse(widgetStore.getCookie("currentUserInfos")).nb_entreprises > 1 && (
                            <>
                                <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", flexShrink: 0}}/>
                                <BtnSecondary onClick={handleChangeEntreprise}>
                                    Changer d'espace
                                </BtnSecondary>
                            </>
                        )}
                    {/* Bouton Back-Office : visible uniquement pour les admins et super admins */}
                    {widgetStore.getCookie("currentUserInfos") && (() => {
                        try {
                            const userInfos = JSON.parse(widgetStore.getCookie("currentUserInfos"));
                            const roleId = entrepriseInfos?.role?.id;
                            // is_admin : champ ajouté côté backend (fix #495) pour éviter de dépendre de role.id
                            // Fallback sur roleId pour les cookies antérieurs au fix
                            const canAccessBo = userInfos.is_super_admin
                                || entrepriseInfos?.is_admin
                                || (roleId && roleId <= 3);
                            if (!canAccessBo) return null;
                            return (
                                <>
                                    <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", flexShrink: 0}}/>
                                    <BtnSecondary onClick={handleOpenBo} disabled={loadingBo}>
                                        {loadingBo ? 'Connexion...' : 'Back-Office'}
                                    </BtnSecondary>
                                </>
                            );
                        } catch { return null; }
                    })()}
                    {/* Déconnexion — toujours en dernier à droite */}
                    <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", flexShrink: 0}}/>
                    <BtnSecondary onClick={() => setShowSignOut(true)} children={"Déconnexion"}/>
                </div>
            </div>
            <SignOut show={showSignOut}/>

            {showHelpUnavailable && (
                <ModalPrimary
                    textTitle="Le centre d’aide se prépare"
                    textComment="Nous peaufinons cet espace pour mieux vous accompagner. Revenez vous connecter un peu plus tard : le centre d’aide sera bientôt disponible."
                    showValidateBtn={false}
                    textBtnCancel="Fermer"
                    onCancel={() => setShowHelpUnavailable(false)}
                />
            )}

            {totemToDelete && (
                <div style={{ position: 'fixed', inset: 0, zIndex: 100000, background: 'rgba(0,35,53,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ModalPrimary
                        textTitle="Supprimer cet écran ?"
                        textComment={`« ${totemToDelete.tot_nom} » et ses widgets ne seront plus accessibles.`}
                        textBtnValidate={isDeletingTotem ? 'Suppression…' : 'Oui, supprimer l’écran'}
                        textBtnCancel="Annuler"
                        onValidate={handleDeleteTotem}
                        onCancel={() => !isDeletingTotem && setTotemToDelete(null)}
                    >
                        {deleteTotemError && <p style={{ color: '#d73737', fontWeight: 700, marginTop: '0.75rem' }}>{deleteTotemError}</p>}
                    </ModalPrimary>
                </div>
            )}

        </div>
    )
})
export default Totem
